import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { Button, Input, Loading } from '@ibk/shared-ui';
import { formatCurrency } from '@ibk/shared-utils';
import styles from './ValueStep.module.css';
export function ValueStep({ data, onNext, onBack, isLoading = false, dataTestId = 'value-step', }) {
    const { t } = useTranslation();
    const [amount, setAmount] = useState(data.amount);
    const [isValid, setIsValid] = useState(false);
    useEffect(() => {
        const numericValue = parseFloat(amount.replace(/[^\d,]/g, '').replace(',', '.'));
        const hasValidAmount = numericValue >= 5;
        setIsValid(hasValidAmount && amount.trim() !== '');
    }, [amount]);
    const handleAmountChange = (event) => {
        const inputValue = event.target.value;
        const numericValue = inputValue.replace(/[^\d]/g, '');
        if (numericValue === '') {
            setAmount('');
            return;
        }
        const numberValue = parseInt(numericValue) / 100;
        const formattedValue = formatCurrency(numberValue);
        setAmount(formattedValue);
    };
    const handleNext = () => {
        if (isValid) {
            onNext({
                ...data,
                amount,
            });
        }
    };
    if (isLoading) {
        return (_jsx("div", { className: styles.container, "data-testid": dataTestId, children: _jsx(Loading, { size: 'medium' }) }));
    }
    return (_jsxs("div", { className: styles.container, "data-testid": dataTestId, children: [_jsxs("div", { className: styles.contentContainer, children: [_jsx("h2", { className: styles.title, children: t('deposit-billet.value.title') }), _jsx("div", { className: styles.inputContainer, children: _jsx(Input, { label: t('deposit-billet.value.amount.label'), placeholder: 'R$ 0,00', value: amount, onChange: handleAmountChange, description: t('deposit-billet.value.amount.helper'), dataTestId: `${dataTestId}-amount`, size: 'large', required: true }) })] }), _jsxs("div", { className: styles.buttonsContainer, children: [_jsx(Button, { variant: 'secondary', size: 'medium', onClick: onBack, dataTestId: `${dataTestId}-back-button`, children: t('deposit-billet.buttons.back') }), _jsx(Button, { variant: 'primary', size: 'medium', onClick: handleNext, disabled: !isValid, dataTestId: `${dataTestId}-next-button`, children: t('deposit-billet.buttons.next') })] })] }));
}
